import React, { Suspense } from 'react'
import type { KambiSportName } from '@mobi/api-types/kambi/sports'
import { SportsIcon } from '@mobi/sports-offering/Components/Common/SportsIcon'
import { mappedSportsWithNationalFlags } from './Components/index'
import { TeamShieldColorsIcon } from '../Common/TeamColorShield'
import { TeamColor } from './Components/types'
import { colors } from '@mobi/component-library/Foundations'

const defaultTeamColor: TeamColor = {
  team: '',
  mainColor: colors.white,
  secondaryColor: '#EDEDED',
}

export const TeamIcon: React.FC<{
  size: string
  participantId: number | null | undefined
  sportName: KambiSportName | undefined
  defaultSportIcon?: 'sport-icon' | 'team-icon' | null
}> = ({ participantId, size, sportName, defaultSportIcon = 'sport-icon' }) => {
  const defaultIcon =
    defaultSportIcon === 'sport-icon' ? (
      <SportsIcon size={size} sport={sportName} />
    ) : defaultSportIcon === 'team-icon' ? (
      <TeamShieldColorsIcon size={size} colors={defaultTeamColor} />
    ) : null

  if (!participantId || !sportName) {
    return defaultIcon
  }
  const MappedIcon = mappedSportsWithNationalFlags[sportName]

  if (!MappedIcon) {
    return defaultIcon
  }

  return (
    <Suspense fallback={null}>
      <MappedIcon
        size={size}
        participantId={participantId}
        sportName={sportName}
        defaultIcon={defaultIcon}
      />
    </Suspense>
  )
}
